export default __webpack_public_path__ + "static/media/fancy_yarn_cone.fa0c9589.png";